import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { UserService } from 'app/shared/services/user/user.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  changePasswordForm!: UntypedFormGroup;
  isConfirm: boolean = false;
  token!: string;
  userId!: string;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private userService: UserService,
    private uiService: UiService,
    private route: ActivatedRoute,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.initComponent();
  }

  onSubmit(): void {
    if (this.f.newPassword.value !== this.f.confirmNewPassword.value) {
      this.uiService.showSnackbar('Les mots de passe ne sont pas identiques')
      this.f.newPassword.reset();
      this.f.confirmNewPassword.reset();
      return;
    }

    const hashedNewPassword = this.authService.cryptString(this.f.newPassword.value);

    // setTimeout(() => {
    //   this.isConfirm = true
    // }, 1000);

    this.userService.resetPassword(this.userId, this.token, hashedNewPassword).subscribe({
      next: () => {
        this.isConfirm = true;
      },
      error: () => {
        this.isConfirm = false;
      }
    })

  }

  private initComponent(): void {
    this.token = this.route.snapshot.queryParams.token;
    this.userId = this.route.snapshot.queryParams.id;

    // this.route.queryParams.subscribe(params => {
    //   this.token = params.token;
    //   this.userId = params.id;
    // });
  }

  get f() {
    return this.changePasswordForm.controls;
  }

  private initForm(): void {
    this.changePasswordForm = this.formBuilder.group({
      newPassword: ['', Validators.required],
      confirmNewPassword: ['', Validators.required],
    })

  }

}
